import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { environment } from '@src/environments/environment';

/*import { LoggerService } from '@app/services/util-services/logger.service';*/

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsUtilLibService {
  constructor() {
    if (environment?.production && environment?.mobileApp) {
      this.initFb().then((r) => {});
    }
  }

  async initFb() {
    // this.deviceInfo = await Device.getInfo();
    if (environment?.mobileApp) {
      this.setCollectionEnabled(true);
    }

    /*if (this.b2bDeviceUtilService?.deviceInfo?.platform === 'web') {
      FirebaseAnalytics.initializeFirebase(environment.firebaseConfig).then(
        (r) => {

          this.setCollectionEnabled(true);
        }
      );
    } else {
      this.setCollectionEnabled(true);
    }*/
  }

  /**
   * Platform: Web/Android/iOS
   * Sets whether analytics collection is enabled for this app on this device.
   * @param name - enabled - boolean true/false
   * @returns void
   */
  setCollectionEnabled(enabled: boolean): void {
    if (environment?.production && environment?.mobileApp) {
      FirebaseAnalytics.setCollectionEnabled({
        enabled,
      }).then((r) => {});
    }
  }

  /**
   * Platform: Web/Android/iOS
   * Sets the user ID property.
   * @param userId - unique identifier of a user
   * @returns void
   * https://firebase.google.com/docs/analytics/userid
   */
  setUserId(userId: string): void {
    if (environment?.production && environment?.mobileApp) {
      FirebaseAnalytics.setUserId({
        userId,
      }).then();
    }
  }

  /**
   * Platform: Android/iOS
   * Sets the current screen name, which specifies the current visual context in your app.
   * @param screenName - name of the current screen to track
   * @param nameOverride - name of the screen class to override
   * @returns instanceId - individual instance id value
   * https://firebase.google.com/docs/analytics/screenviews
   */
  setScreenName(screenName: string, nameOverride?: string): void {
    if (environment?.production && environment?.mobileApp) {
      FirebaseAnalytics.setScreenName({
        screenName,
        nameOverride,
      }).then();
    }
  }

  /**
   * Platform: Web/Android/iOS
   * Logs an app event.
   * @param name - name of the event to log
   *        params - key/value pairs of properties (25 maximum per event)
   * @returns void
   */
  fireEvent(eventName: string, params: any): void {
    /*LoggerService.log(
      'Firing firebase event ',
      eventName,
      ' params is ',
      params
    );*/

    if (environment?.production && environment?.mobileApp) {
      FirebaseAnalytics.logEvent({
        name: eventName,
        params,
      }).then((r) => {});
    }
  }

  fireBookingEvent(eventName: string, params: any): void {
    if (environment?.production && environment?.mobileApp) {
      const finalParams = {
        transaction_id: params?.analyticsInfo?.order_id,
        value: params?.analyticsInfo?.order_value,
        currency: 'INR',
      };

      FirebaseAnalytics.logEvent({
        name: eventName,
        params: finalParams,
      }).then((r) => {});
    }
  }
}
